module.exports = __webpack_public_path__ + "static/media/64-ptown.a288efb5.jpg";